module.exports = "h1 {\n  margin: 0 auto;\n  font-size: 0.875rem; }\n\n.camera-list {\n  margin: 0 auto; }\n\n.camera-item {\n  border: none;\n  color: #fff;\n  background: transparent;\n  border: 1px solid transparent; }\n\n.camera-item.active {\n    border-color: #fff;\n    border-radius: 6px; }\n\n.camera-item:focus {\n    -webkit-box-shadow: none;\n    box-shadow: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/camera-selector/camera-selector.component.scss
// module id = ./src/app/shared/components/camera-selector/camera-selector.component.scss
// module chunks = main